import { render, staticRenderFns } from "./ContactSelect.vue?vue&type=template&id=b196b122"
import script from "./ContactSelect.vue?vue&type=script&lang=js"
export * from "./ContactSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports